export { WidgetsGridComponent } from './widgets-grid.component';



// WEBPACK FOOTER //
// ./src/app/shared/widgets/widgets-grid/index.ts